import type { Variants } from "framer-motion";

// Shared scroll-reveal variants. Sections use whileInView with these so motion
// is consistent and (via Framer + the CSS media query) reduced-motion safe.

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

export const fade: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.7, ease: "easeOut" } },
};

export const stagger: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.94 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

// Standard viewport config — reveal as soon as a sliver enters, only once.
// Low amount + no negative margin so tall sections reliably un-hide on iOS
// Safari (a high threshold can leave them stuck at opacity:0 until you scroll).
export const inView = { once: true, amount: 0.1 } as const;
